<template>
  <div style="background:#fff;height:100vh;  overflow: scroll;">
    <div class="marginBox">
      <!-- 常用功能 -->
      <div class="commonFunctions">
        <div class="topTitel">
          <div class="titelSpan">常用功能</div>
        </div>
        <div class="iconBox">
          <div class="iconItem" v-for="(item, index) in iconList" :key="index">
            <img :src="item.icon" @click="toDetail(index, item.label)" />
            <div class="mt10">{{ item.label }}</div>
          </div>
          <!-- <div class="iconItem">
            <div class="addIcon">
              <i class="el-icon-plus"></i>
            </div>
            <div class="mt10">编辑常用功能</div>
          </div> -->
        </div>
      </div>
      <div class="secondBox">
        <div style="width:65%;">
          <!-- 经营推荐 -->
          <div class="commonFunctions" style="width: 100%;">
            <div class="topTitel">
              <div class="titelSpan">经营推荐</div>
            </div>
            <div class="contentBox">
              <div
                class="contentItem"
                v-for="(item, index) in businessList"
                :key="index"
              >
                <div class="logoBox">
                  <img
                    :src="item.icon"
                    alt=""
                    style="width: 24px;height:24px;"
                  />
                  <span class="ml10" style="font-size:13px">{{
                    item.name
                  }}</span>
                </div>
                <div class="detailBox" style="font-size:12px">
                  {{ item.content }}
                </div>
                <div class="activeBox" @click="toNext(index)">
                  {{ item.next }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width:30%;">
          <div class="commonFunctions" style="width: 100%;">
            <div class="topTitel">
              <div class="titelSpan">下载收银管家App</div>
              <div>更多下载》</div>
            </div>
            <div class="pd20 flex">
              <img
                src="../../../assets/images/dianjiaoshouLogo.png"
                alt=""
                style="width:105px;heigth:170px;"
              />
              <div class="ml20">
                <div class="f13">收银管家app</div>
                <div class="detailBox">手机版商家后台，随时随地管理餐厅</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  -->
      <div class="swiperBox">
        <el-carousel trigger="click" height="90px" arrow="never">
          <el-carousel-item>
            <img
              src="../../../assets/images/swiper1.jpg"
              @click="open('https://train.yunlankeji.com/#/windows')"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconList: [
        {
          icon: require("../../../assets/images/index/icon1.png"),
          label: "菜品库"
        },
        {
          icon: require("../../../assets/images/index/icon2.png"),
          label: "员工账号"
        },
        {
          icon: require("../../../assets/images/index/icon3.png"),
          label: "券类管理"
        },
        {
          icon: require("../../../assets/images/index/icon-1.png"),
          label: "打印机管理"
        },
        {
          icon: require("../../../assets/images/index/icon4.png"),
          label: "结账方式管理"
        },
        {
          icon: require("../../../assets/images/index/icon5_replace.png"),
          label: "扫码点单"
        },
        {
          icon: require("../../../assets/images/index/icon6_replace.png"),
          label: "桌台管理"
        }
      ],
      businessList: [
        {
          icon: require("../../../assets/images/index/mt.png"),
          name: "美团外卖",
          content: "收银及自动接单，自动打印外卖后厨制作",
          next: "去开通"
        },
        {
          icon: require("../../../assets/images/index/member.png"),
          name: "会员管理",
          content: "全渠道会员快速获客，会员营销拉高客单价",
          next: "去查看"
        },
        {
          icon: require("../../../assets/images/index/report.png"),
          name: "报表中心",
          content: "营收概览快速了解店内运营情况，经营数字化管理办法",
          next: "去查看"
        }
      ]
    };
  },
  methods: {
    toDetail(index, label) {
      if (label == "菜品库") {
        this.$router.push("/merchantProduct");
      } else if (label == "员工账号") {
        this.$router.push("/merchantUser");
      } else if (label == "券类管理") {
        this.$router.push("/couponManage");
      } else if (label == "结账方式管理") {
        this.$router.push("/merchantOrderPayType");
      } else if (label == "扫码点单") {
        this.$router.push("/scanOrder");
      } else if (label == "桌台管理") {
        this.$router.push("/merchantArea");
      } else if (label == "打印机管理") {
        this.$router.push("/printerManagement");
      }
    },
    toNext(index) {
      if (index == "0") {
        this.$router.push("/meituanTakeAwayStoreBind");
      } else if (index == "1") {
        this.$router.push({ path: "/merchantMember" });
      } else if (index == "2") {
        this.$router.push("/shiftRecord");
      }
    },
    open(url) {
      let link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.swiperBox {
  width: 95%;
  height: 90px;
  margin: 0 auto;
  border: 1px solid #c8c8c8;
  background-color: #ffbd00;

  .el-carousel__item {
    height: 100%;
    width: 100%;
  }

  img {
    height: 100%;
    width: 100%;
  }
}

.marginBox {
  width: 100%;
  padding-top: 20px;
}

.commonFunctions {
  width: 95%;
  margin: 0 auto;
  border: 1px solid rgb(200, 200, 200);
  // margin-top: 50px;
}

.topTitel {
  // width: 90%;
  padding: 20px 30px;
  color: #000;
  border-bottom: 1px solid rgb(200, 200, 200);
  z-index: 1;
  display: flex;
  justify-content: space-between;
}

.titelSpan {
  z-index: 3;
  width: fit-content;
  position: relative;
}

.titelSpan::after {
  content: "";
  width: 100%;
  height: 5px;
  border-radius: 5px;
  background: #ffbd00;
  position: absolute;
  left: 0;
  z-index: -1;
  bottom: 2px;
}

.iconBox {
  width: 100%;
  // height: 500px;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 30px;
}

.iconItem {
  width: 16%;
  // height: 100px;
  text-align: center;
  margin-top: 50px;
  font-size: 18px;

  .mt10 {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}

.iconItem img {
  // width: 70px;
  // height: 70px;
  height: 48px;
  width: 48px;
  margin: 0 auto;
  cursor: pointer;
}

.addIcon {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  background: rgb(245, 154, 35);
  border-radius: 10px;
  color: #fff;
  line-height: 70px;
  font-weight: 900;
  font-size: 25px;
  cursor: pointer;
}

.secondBox {
  display: flex;
  justify-content: space-between;
  width: 95%;
  margin: 0 auto;
  margin-top: 24px;
  margin-bottom: 24px;
}

.contentBox {
  width: 100%;
  display: flex;
}

.contentItem {
  width: 33.3%;
  border-right: 1px solid rgb(200, 200, 200);
  padding: 20px;
}

.contentItem:nth-last-child(1) {
  border-right: none;
}

.logoBox {
  display: flex;
  align-items: center;
}

.detailBox {
  font-size: 14px;
  color: #999;
  margin-top: 15px;
}

.activeBox {
  font-size: 14px;
  margin-top: 15px;
  color: rgb(238, 108, 32);
  cursor: pointer;
  width: fit-content;
}

.pd20 {
  padding: 20px;
}
</style>
